/* eslint-disable react/prop-types */
import React from "react";
import dayjs from "dayjs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Rating from "react-rating";
import { starsFrom } from "./conversationStats";

// Shared by the page's results table and the chart drill-down modal.
const conversationColumns = [
    {
        accessor: 'createdDate',
        Header: 'Created',
        isVisible: true,
        Cell: ({ value }) => dayjs(value).format("DD/MM/YYYY HH:mm:ss")
    },
    {
        accessor: 'knowledgeName',
        Header: 'Knowledge',
        isVisible: true,
    },
    {
        accessor: 'question',
        Header: 'Question',
        isVisible: true,
        Cell: ({ value }) => {
            return <span title={value} className="d-inline-block text-truncate" style={{ maxWidth: '350px' }}>{value}</span>
        }
    },
    {
        accessor: 'answer',
        Header: 'Answer',
        isVisible: true,
        Cell: ({ value }) => {
            return <span title={value} className="d-inline-block text-truncate" style={{ maxWidth: '350px' }}>{value}</span>
        }
    },
    {
        accessor: 'user',
        Header: 'User',
        isVisible: true,
    },
    {
        accessor: 'rating',
        Header: 'Rating',
        isVisible: true,
        Cell: ({ value }) => {
            const stars = starsFrom(value);
            // A null rating is not zero stars, so say so rather than drawing an empty row.
            if (stars === null) return <span className="text-600">—</span>;
            return (
                <Rating
                    initialRating={stars}
                    readonly={true}
                    fullSymbol={<FontAwesomeIcon icon="star" className="text-primary me-1" />}
                    emptySymbol={<FontAwesomeIcon icon="star" className="text-300 me-1" />}
                />
            )
        }
    }
];

export default conversationColumns;
